// extracted by mini-css-extract-plugin
export default {"navigation":"Navbar_navigation__aQtGH","hovered":"Navbar_hovered__oiBQo","icon":"Navbar_icon__hGvZT","title":"Navbar_title__375uB"};